<div class="container-fluid" [formGroup]="declarationForm">

    <p class="texte-info-cnaf">Tous les champs sont obligatoires, sauf mention contraire.</p>
    <app-info-logement
        name="infoLogement"
        [logementModel]="logementModel"
        (logementModelEvent)="recupererLogementModel($event)">
    </app-info-logement>

    <app-sitfam
        *ngIf="declarationForm.controls['infoLogement']?.valid"
        name="sitFam"
        [sitFamModel]="sitFamModel"
        (sitFamModelEvent)="recupererSitFam($event)">
    </app-sitfam>

    <app-personnes
        *ngIf="declarationForm.controls['sitFam']?.valid"
        name="personnes"
        [isCouple]="sitFamModel.enCouple"
        [nbEnfants]="sitFamModel.nbEnfants"
        [listePersonnes]="listePersonnes"
        (listePersonnesEvent)="recupererListePersonnes($event)">
    </app-personnes>

    <!-- Barre de bouton -->
    <div class="row row-btn-cnaf">
        <div class="col-sm-12 form-group">
            <app-bouton-quitter [pageName]="pageName"></app-bouton-quitter>
            <span class="float-end">
                <button
                    *ngIf="sitFamModel.getNbEnfants() > 0"
                    [disabled]="!declarationForm.controls['personnes']?.valid"
                    id="btn-suivant" name="BCSuivant"
                    type="submit" value="Continuer"
                    title="Continuer" class="btn btn-form-cnaf btn-majeur-cnaf btn-mobile"
                    (click)="clickSuivant()"
                    style="pointer-events: all; cursor: pointer;">
                    Continuer
                </button>
                <button
                    *ngIf="!(sitFamModel.getNbEnfants() > 0)"
                    [disabled]="!declarationForm.controls['personnes']?.valid"
                    id="btn-suivant" name="BCSuivant"
                    type="submit" value="Calculer"
                    title="Calculer" class="btn btn-form-cnaf btn-majeur-cnaf btn-mobile"
                    (click)="clickCalculer()"
                    style="pointer-events: all; cursor: pointer;">
                    Calculer
                </button>
            </span>
        </div>
    </div>

    <div class="row" *ngIf="isPageErreur" >
        <div class="col-sm-12 center-middle-block">
            <div class="alert alert-danger" role="alert" style="margin-top:10px">
                <span class="glyphicon glyphicon-alert" aria-hidden="true"></span>
                Une erreur est survenue pendant le calcul des droits.
                <br/>
                Vous pouvez réessayer en cliquant de nouveau sur le bouton Calculer.
            </div>
        </div>
    </div>

</div>
